<div class="row mb-2">
    <div class="col">
        <div widget class="card border-0 box-shadow">
           
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row mt-2 mb-2">
                    <div class="col">
                        <button type="button" class="btn  btn-sm" data-bs-toggle="modal"
                            data-bs-target="#CreateTaxPercentmodal" (click)="clearTaxPercent()"  *ngIf="fp.taxpercentcreate">Add
                            Tax Percent</button>
                    </div>
                    <div class="col text-end">
                        <button type="button" class="btn  btn-sm " (click)="Refresh()">
                            <i class="fa fa-repeat"> Refresh </i>
                        </button>
                    </div>
                </div>
                          <!-- ejs-grid -->
                <div class="row mt-4 pt-2" style="min-height: 500px;">
                    <div class="col">
                        <ejs-grid #gridTaxPercent [dataSource]='GridList | async' [allowPaging]='true'
                        [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                        [allowResizing]='true' (dataStateChange)='dataChangeTaxPercent($event)' [showColumnChooser]='true'
                        (actionBegin)="onActionTaxpercent($event)" [allowSorting]='true'>
                        <e-columns>
                            <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                <ng-template #template let-data>
                                    <button class="btn btn-edit-table" data-bs-toggle="modal" *ngIf="fp.taxpercentupdate"
                                        data-bs-target="#CreateTaxPercentmodal" (click)="getDetails(data)"><i
                                            class="fa fa-edit"></i></button>&nbsp;
                                    <button class="btn btn-delete-table" data-bs-toggle="modal"  *ngIf="fp.taxpercentdelete"
                                        data-bs-target="#deleteTaxPercentmodal" (click)="getDetails(data)"><i
                                            class="fa fa-trash"></i></button>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="taxName" headerText="Tax Name" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="taxDescription" headerText="Tax Description" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="effectiveDate" headerText="Effective Date" 
                            [format]='formatOptions' type="date" [allowFiltering]='false' [allowSorting]='false'> 
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="percent" headerText="Percent" type="number">
    
                            </e-column>
    
                            <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                    <div>
                                        <span id='show' (click)='showTaxPercentColumns()'><i class="fa fa-cog fa-lg"
                                                aria-hidden="true">
                                            </i></span>
                                    </div>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- For Create or Update Modal -->
<span id="openTaxPercentModal" data-bs-toggle="modal" data-bs-target="#CreateTaxPercentmodal"></span>
<div class="modal fade" id="CreateTaxPercentmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span
                        *ngIf="saveTaxPercentageInfo.id == '00000000-0000-0000-0000-000000000000'">
                        Create Taxs Percent</span>
                    <span *ngIf="saveTaxPercentageInfo.id !='00000000-0000-0000-0000-000000000000'">Update Taxs
                        Percent</span>
                </h5>
                <button type=" button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" (click)="clearTaxPercent()"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-5">
                        <label>Effective Date<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <my-date-picker [options]="myDatePickerOptions" [selDate]="saveTaxPercentageInfo.effectiveDate"
                            placeholder="mm/dd/yyyy"
                            (inputFieldChanged)="DateFormat($event,'inputchanged','EffectiveDate')"
                            (dateChanged)="DateFormat($event,'datechanged','EffectiveDate')">
                        </my-date-picker>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Percent<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="number" class="form-control" [(ngModel)]="saveTaxPercentageInfo.percent" />
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Tax<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <ng-select [items]="TaskPercentdropdown" class="width25" [searchable]="true"   [clearable]="true" bindLabel="name"
                        bindValue="id" [(ngModel)]="saveTaxPercentageInfo.taxId">
                      </ng-select>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="SaveOrUpdateTaxPercentList();" [disabled]="saveTaxPercentageInfo.taxId==null ||
                saveTaxPercentageInfo.taxId==undefined || saveTaxPercentageInfo.taxId==''||
                saveTaxPercentageInfo.percent==null ||
                saveTaxPercentageInfo.percent==undefined || saveTaxPercentageInfo.percent==0 ||
                saveTaxPercentageInfo.effectiveDate==null ||
                saveTaxPercentageInfo.effectiveDate==undefined || saveTaxPercentageInfo.effectiveDate==''
                "><span *ngIf="saveTaxPercentageInfo.id == '00000000-0000-0000-0000-000000000000'"> Save &
                        Close</span> <span
                        *ngIf="saveTaxPercentageInfo.id != '00000000-0000-0000-0000-000000000000'">Update &
                        Close</span> </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearTaxPercent()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- For Delete Modal -->
<span id="closeTaxPercentModal" data-bs-target="#deleteTaxPercentmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteTaxPercentmodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteTaxPercent()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="clearTaxPercent()"
                    data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>